
import axios from "axios"
import {defineComponent} from 'vue'
import {Locales} from "@/i18n/locales";
import Dropdown from 'primevue/dropdown';
import AutoComplete from "primevue/autocomplete";
import {taxonByIdURL, taxonByNameURL} from "@/config/app-settings";
import {debounce} from "lodash";


export default defineComponent({
  name: "CategoryPicker",
  components: {Dropdown, AutoComplete},
  data() {
    return {
      options: [],
      isActive: false,
      selected: null as any,
      selectedTaxon: null as any,
      loading: false,
      filteredItems: null
    }
  },
  props: {
    api: {type: String, required: true},
    name: {type: String, required: true},
    value: {type: Number, required: true},
    clearable: {type: Boolean, required: false, default: true},
    filter: {type: Boolean, required: false, default: true},
    lazy: {type: Boolean, required: false, default: false},
  },
  computed: {
    lang(): Locales {
      return this.$store.state.language
    },
    storedSubstrateCoarse(): Number {
      return this.$store.state.substrateCoarse
    }
  },

  methods: {
    getRequestURI(api: string) {
      // check for additional request params with ? in URI, eg. for api?param=1&lang=de to concatenate URI
      return api.includes('?') ? api + '&lang=' + this.$store.state.language : api + '?lang=' + this.$store.state.language
    },
    getOptions() {
      this.loading = true

      if (this.name == 'substrateFine') {
        if (this.$store.state.substrateCoarse) {
          axios.get(this.getRequestURI(this.api) + '&substrateCoarse=' + this.$store.state.substrateCoarse)
              .then((res) => {
                    this.options = res.data
                    this.loading = false
                  }
              )
              .catch((e) => console.log(e))
        } else {
          this.selected = null
        }

      } else {
        axios.get(this.getRequestURI(this.api))
            .then((res) => {
                  this.options = res.data
                  this.loading = false
                }
            )
            .catch((e) => console.log(e))
      }

    },


    searchItems: debounce(function (this: any, event: any) {

      axios.get(taxonByNameURL + '?query=' + event.query)
          .then((res) => {
                this.filteredItems = res.data
                this.loading = false
              }
          )
          .catch((e) => console.log(e))

    }, 500),
    loadTaxon() {
      if (this.name == 'taxonId' && this.value) {
        axios.get(taxonByIdURL + '?taxonId=' + this.value)
            .then((res) => {
                  // @ts-ignore
                  this.selectedTaxon = res.data[0].LABEL
                }
            )
            .catch(e => console.log(e))
      }
    },
    select(value: any) {
      this.selected = value
      if (this.name == 'substrateCoarse') {
        this.$store.commit('setSubstrateCoarse', value)
        this.$emit('select', {key: this.name, value: value})
      } else if (this.name == 'taxonId' && value === null) {
        // avoid resetting taxon and force selection of a taxon
      } else {
        this.$emit('select', {key: this.name, value: value})
      }


    }
  },
  watch: {
    selected() {
      console.log("watch selected", this.selected)
    },
    api: {
      handler() {
        this.getOptions()
      },
      immediate: true
    },
    lang() {
      this.getOptions()
    },
    storedSubstrateCoarse() {
      // check and reset dependent lists
      if (this.name == 'substrateFine') {
        if (this.storedSubstrateCoarse) {
          this.select(null)
          this.getOptions()
        } else {
          this.select(null)
        }
      } else if (['woodDegradation', 'woodQuality'].includes(this.name)) {
        if (this.storedSubstrateCoarse !== 3) {
          this.select(null)
        }
      } else if (['hostLichen'].includes(this.name)) {
        if (this.storedSubstrateCoarse !== 11) {
          this.select(null)
        }
      } else if (['hostFungus'].includes(this.name)) {
        if (this.storedSubstrateCoarse !== 8) {
          this.select(null)
        }
      }
    }
  },
  beforeMount() {
    this.select(this.value)
    this.loadTaxon()


  }

})
